<template>
  <Modal v-model="designRepetitionPromptModal" :title="$t('key1000341')" class-name="commonModalStyles"
    width="700" :transfer="false" :mask-closable="false">
    <h2 class="mb12 font-size-14 color-333 font-weight-bold">{{ $t('key1000342') }}</h2>
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button type="primary" @click="designRepetitionPromptModal = false">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {isJSON, EventBus} from "@/utils/common";

export default {
  name: 'designRepetitionPromptModal',
  mixins: [Mixin],
  data() {
    return {
      designRepetitionPromptModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000339'),
          key: 'customizedSku',
          align: 'center',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000340'),
          key: 'ymsSku',
          align: 'center',
          minWidth: 160
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    EventBus.$on('initCustomizedProductDesignRepetitionData', (data) => {
      this.tableData = [];
      if (data) {
        if (isJSON(data)) {
          this.tableData = JSON.parse(data);
        }
      }
      this.designRepetitionPromptModal = true;
    });
  },
  beforeDestroy() {
    EventBus.$off('initCustomizedProductDesignRepetitionData');
  }
};
</script>

<style lang="less">

</style>
